/// <reference types="./ambient-ripple" />
export * from './Ripple.js';
import Ripple from './Ripple.js';
export default Ripple;
//# sourceMappingURL=index.js.map